import React, { PureComponent } from 'react';
import './Confirm.less'

class Confirm extends PureComponent {
  render() {
    const { subjects, onConfirm, onBackToModify } = this.props;
    return (
      <div className="subject-choice-wrapper">
        <div className="subject-choice-inner">
          <h1>确认你的选科意向</h1>
          <p>你选择的三个科目是</p>
          <div className="chosen-subjects">
            {subjects.map(d => (
              <div key={d.id} className="subject">{d.name}</div>
            ))}
          </div>
          <p className="notice">你本次的选科决策将提交至学校，并且它可能也将影响你在各个方向上的探索。确定这个选择吗？</p>
        </div>
        <div className="subject-choice-bottom two-choice">
          <button className="primary full" onClick={onConfirm}>确认选择</button>
          <button className="full" onClick={onBackToModify}>返回修改</button>
        </div>
      </div>
    );
  }
}

export default Confirm;


// WEBPACK FOOTER //
// ./src/pages/SubjectChoice/Confirm.js